module.exports = __webpack_public_path__ + "img/4.78b55a68.png";